import request from '../utils/request';
//会员页面数据
export function annualMember(data) {
  return request({
    url: 'wap/tyUser/annualMember.do',
    method: 'post',
    data
  })
}
//会员权益列表
export function toMyZYKCourseList(data) {
  return request({
    url: '/wab/lib/toMyZYKCourseList.do',
    method: 'post',
    data
  })
}
//资源库列表
export function toCourseList(data) {
  return request({
    url: '/wab/lib/toCourseList.html',
    method: 'post',
    data
  })
}
//资源库分类
export function getCodeList(data) {
  return request({
    url: '/wab/lib/getCodeList.html',
    method: 'post',
    data
  })
}
//会员权益下单
export function toGenerateMemberOrder(data) {
  return request({
    url: '/wap/tyOrder/toGenerateMemberOrder.do',
    method: 'post',
    data
  })
}
//课程资源库播放
export function toCourseDetail(data) {
  return request({
    url: '/wab/lib/toCourseDetail.html',
    method: 'post',
    data
  })
}
//课程资源库试听
export function findCourseChapterList(data) {
  return request({
    url: '/wab/lib/findCourseChapterList.html',
    method: 'post',
    data
  })
}




